import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=8b418ace&scoped=true"
import script from "./goodsItem.vue?vue&type=script&lang=js"
export * from "./goodsItem.vue?vue&type=script&lang=js"
import style0 from "./goodsItem.vue?vue&type=style&index=0&id=8b418ace&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b418ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b418ace')) {
      api.createRecord('8b418ace', component.options)
    } else {
      api.reload('8b418ace', component.options)
    }
    module.hot.accept("./goodsItem.vue?vue&type=template&id=8b418ace&scoped=true", function () {
      api.rerender('8b418ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spellGroup/goodsList/components/goodsItem.vue"
export default component.exports